import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { FrBoloProviders } from '../fr-bolos-page/state/fr-bolo-providers';

export function FrBoloRootProviders() {
    const params = useParams();
    const paramsBoloId = params.boloId ? Number(params.boloId) : undefined;

    return (
        <FrBoloProviders boloId={paramsBoloId}>
            <Outlet />
        </FrBoloProviders>
    );
}
